import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import Button from '@/components/form/Button';
import { useAuth } from '@/context/AuthContext';

export default function Terms() {
  const { user } = useAuth();

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl my-10">
      {!user && (
        <Button
          variant="ghost"
          size="sm"
          icon={<ArrowLeftIcon className="h-4 w-4" />}
          onClick={() => window.location.href = '/'}
          className="mb-6"
        >
          Back to Home
        </Button>
      )}

      <h1 className="text-4xl font-extrabold text-blue-600 mb-10 text-center">Terms of Service</h1>

      <div className="prose prose-lg prose-blue max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">1. Agreement to Terms</h2>
          <div className="mt-4 text-gray-700">
            <p>
              By accessing and using SnapVote ("we," "our," or "us"), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">2. Use License</h2>
          <div className="mt-4 text-gray-700">
            <p>Permission is granted to temporarily access SnapVote for personal, non-commercial use subject to the following conditions:</p>
            <ul className="mt-4 list-disc pl-6">
              <li>You must not modify or copy the materials</li>
              <li>You must not use the materials for any commercial purpose</li>
              <li>You must not attempt to reverse engineer any software contained on SnapVote</li>
              <li>You must not remove any copyright or other proprietary notations</li>
            </ul>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">3. User Accounts</h2>
          <div className="mt-4 text-gray-700">
            <p>When creating an account, you agree to:</p>
            <ul className="mt-4 list-disc pl-6">
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Not share your account credentials</li>
            </ul>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">4. User Content</h2>
          <div className="mt-4 text-gray-700">
            <p>By posting content on SnapVote, you:</p>
            <ul className="mt-4 list-disc pl-6">
              <li>Grant us the right to use, modify, and distribute your content</li>
              <li>Confirm you have the right to share the content</li>
              <li>Accept responsibility for the content you post</li>
              <li>Agree not to post harmful, illegal, or offensive content</li>
            </ul>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">5. Prohibited Activities</h2>
          <div className="mt-4 text-gray-700">
            <p>You must not:</p>
            <ul className="mt-4 list-disc pl-6">
              <li>Use the service for unlawful purposes</li>
              <li>Harass, abuse, or harm others</li>
              <li>Spam or send unsolicited messages</li>
              <li>Attempt to access unauthorized areas</li>
              <li>Interfere with the proper working of the service</li>
            </ul>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">6. Disclaimer</h2>
          <div className="mt-4 text-gray-700">
            <p>
              SnapVote is provided "as is" without warranties of any kind. We do not guarantee that the service will be uninterrupted, secure, or error-free.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">7. Limitation of Liability</h2>
          <div className="mt-4 text-gray-700">
            <p>
              SnapVote shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the service.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">8. Changes to Terms</h2>
          <div className="mt-4 text-gray-700">
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material changes via email or through the website.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">9. Governing Law</h2>
          <div className="mt-4 text-gray-700">
            <p>
              These terms shall be governed by and construed in accordance with the laws of Germany, without regard to its conflict of law provisions.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 border-b pb-2">10. Contact</h2>
          <div className="mt-4 text-gray-700">
            <p>
              For any questions regarding these Terms of Service, please contact us at:{' '}
              <a href="mailto:info@snapvote.ai" className="text-primary-600 hover:text-primary-700">
                info@snapvote.ai
              </a>
            </p>
          </div>
        </section>

        <footer className="mt-12 pt-8 border-t text-center text-gray-500">
          Last updated: March 20, 2025
        </footer>
      </div>
    </div>
  );
}